import { render, staticRenderFns } from "./ModernSlaveryStatement.vue?vue&type=template&id=13914c0a&"
import script from "./ModernSlaveryStatement.vue?vue&type=script&lang=js&"
export * from "./ModernSlaveryStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports